
import { homeConstants } from './constants';

var viewActions = require ('../../store/view.actions');

var homeService = require ('./api');

export const homeActions = {
    getMyDebt
    
};  


function getMyDebt(token) { 
    return dispatch => {
            dispatch(viewActions.isLoadingModule('getMyDebt',true)) ;
         
            homeService.getMyDebt( token )
            .then( json => {
                dispatch({
                  type: homeConstants.STUDENT_DEBT,
                  myDebts: json
                })
                dispatch(viewActions.isLoadingModule('getMyDebt',false)) ;
            } )
            
    }
  }
  